module.exports = __webpack_public_path__ + "static/media/delete.d9bf4bd5.svg";